module.exports = __webpack_public_path__ + "static/media/compress-alt.aa6199cb.svg";